// extracted by mini-css-extract-plugin
export default {"container":"Pedidos_container__mqMNL","sectionConteudo":"Pedidos_sectionConteudo__4dV8H","pedidosContainer":"Pedidos_pedidosContainer__bJKV2"};